import {
  StringBuilder_init_$Create$2mwec1027v00x as StringBuilder_init_$Create$,
  Unit_instance104q5opgivhr8 as Unit_instance,
  decodeToString1x4faah2liw2p as decodeToString,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  replace3le3ie7l9k8aq as replace,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  endsWith3cq61xxngobwh as endsWith,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  protoOf180f3jzyo7rfj as protoOf,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  isInterface3d6p8outrmvmk as isInterface,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  VOID7hggqo3abtya as VOID,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  emptyList1g2z5xcrvp2zy as emptyList,
  getKClass1s3j9wy1cofik as getKClass,
  Companion_instance3fplhgf4ipvld as Companion_instance,
  arrayOf1akklvh2at202 as arrayOf,
  createKType1lgox3mzhchp5 as createKType,
  _Result___init__impl__xyqfz81wclroc5pw7j2 as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  CancellationException3b36o9qz53rgr as CancellationException,
  _Result___get_value__impl__bjfvqgo6z1uu11rodr as _Result___get_value__impl__bjfvqg,
  _Result___get_isFailure__impl__jpirivzehaw445b0cy as _Result___get_isFailure__impl__jpiriv,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
  Enum3alwj03lh1n41 as Enum,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  Long2qws0ah9gnpki as Long,
  Result3t1vadv16kmzk as Result,
  Result__exceptionOrNull_impl_p6xea9boty10p2dkn4 as Result__exceptionOrNull_impl_p6xea9,
  LinkedHashMap_init_$Create$1p3p95clvi93w as LinkedHashMap_init_$Create$,
} from './kotlin-kotlin-stdlib.mjs';
import {
  ByteArrayContent2n0wb43y6ugs1 as ByteArrayContent,
  Companion_getInstancepumzx9q4106p as Companion_getInstance,
} from './ktor-ktor-http.mjs';
import { jsonu6qnfo3b405p as json } from './ktor-ktor-shared-ktor-serialization-ktor-serialization-kotlinx-ktor-serialization-kotlinx-json.mjs';
import {
  headers24pki7ce1busg as headers,
  get_UserAgent1tqbmdxoguusg as get_UserAgent,
  defaultRequest2ux1d5xxixv6z as defaultRequest,
  Sender4pyqqer9k7up as Sender,
  HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder,
  Plugin_getInstanced834gx2fh8tl as Plugin_getInstance,
  plugin3vxt624hnu3pv as plugin,
  url2l6iw5ri21nxb as url,
  HttpStatement3zxb33q8lku as HttpStatement,
  bodyAsText3vst3l5mns5py as bodyAsText,
  Js_instance3bkccyof8y1tc as Js_instance,
  HttpClient2x7qc5z8fmeal as HttpClient,
  bearerAuthj128my0vj44j as bearerAuth,
} from './ktor-ktor-client-ktor-client-core.mjs';
import { get_ContentNegotiationcp59ye9rorjc as get_ContentNegotiation } from './ktor-ktor-client-ktor-client-plugins-ktor-client-content-negotiation.mjs';
import {
  Companion_instancebove5hxj27a1 as Companion_instance_0,
  BreadcrumbCategory_CURL_getInstance2710rz708mc5v as BreadcrumbCategory_CURL_getInstance,
  BreadcrumbCategory_RESPONSE_getInstance2la5p5q0jyryh as BreadcrumbCategory_RESPONSE_getInstance,
  ILoggingProvider3qgs59b4tde8f as ILoggingProvider,
} from './Shared7Punches-infrastructure-logging.mjs';
import { Jsonsmkyu9xjl7fv as Json } from './kotlinx-serialization-kotlinx-serialization-json.mjs';
import {
  Companion_getInstance1rlvzabi952im as Companion_getInstance_0,
  Kind_Factory_getInstance2ge7vb99ubfwr as Kind_Factory_getInstance,
  BeanDefinitionhif1nxb54kgk as BeanDefinition,
  FactoryInstanceFactory2tq2q9e5id3pz as FactoryInstanceFactory,
  KoinDefinition2pr0kscd0vkk6 as KoinDefinition,
  module39wmcymxxg0fj as module_0,
} from './projects-core-koin-core.mjs';
import {
  IEnvironmentProvider2spq4fpbokmem as IEnvironmentProvider,
  Companion_instance38at02i5wbrbj as Companion_instance_1,
  Conflict1e0yfippryym4 as Conflict,
  NotFoundzza6y93k8gbh as NotFound,
  Forbidden31h9i07nwe7so as Forbidden,
  Unauthorized2vw47nfko1hfy as Unauthorized,
  BadRequest1sf43sgrco9q2 as BadRequest,
} from './Shared7Punches-common-base.mjs';
import {
  TypeInfo2nbxsuf4v8os2 as TypeInfo,
  appendIfNameAbsent2ezf2rzparych as appendIfNameAbsent,
} from './ktor-ktor-utils.mjs';
import {
  PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor,
  UnknownFieldException_init_$Create$1mnsp66c6fnup as UnknownFieldException_init_$Create$,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
  StringSerializer_getInstance1k1oz5j50sfik as StringSerializer_getInstance,
  get_nullable197rfua9r7fsz as get_nullable,
  IntSerializer_getInstance9scrtcljaiv6 as IntSerializer_getInstance,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  asyncz02dsa2nb2zt as async,
  coroutineScope327xjtgzh1k2v as coroutineScope,
  Mutex16li1l0asjv17 as Mutex,
} from './kotlinx-coroutines-core.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForLambda(Client$Companion$create$slambda, CoroutineImpl, VOID, [2]);
initMetadataForLambda(Client$Companion$create$slambda_1, CoroutineImpl, VOID, [2]);
initMetadataForCompanion(Companion);
initMetadataForClass(Client, 'Client');
initMetadataForCoroutine($mapApiErrorResponseCOROUTINE$0, CoroutineImpl);
initMetadataForCompanion(Companion_0);
initMetadataForClass(ApiVersion, 'ApiVersion', VOID, Enum);
initMetadataForClass(ProjectInfo, 'ProjectInfo');
initMetadataForInterface(INetworkDataProvider, 'INetworkDataProvider', VOID, VOID, VOID, [0]);
initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Meta, 'Meta', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
initMetadataForClass(Cursor, 'Cursor', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
initMetadataForCompanion(Companion_1, VOID, [SerializerFactory]);
initMetadataForClass($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiPaginatedResponse, 'ApiPaginatedResponse', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_3});
initMetadataForCompanion(Companion_2);
initMetadataForObject($serializer_2, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ErrorResponse, 'ErrorResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
initMetadataForCoroutine($getRawCOROUTINE$1, CoroutineImpl);
initMetadataForLambda(NetworkJobManager$registerJob$slambda$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(NetworkJobManager$registerJob$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCoroutine($executeCOROUTINE$2, CoroutineImpl);
initMetadataForCoroutine($registerJobCOROUTINE$3, CoroutineImpl);
initMetadataForCoroutine($unregisterJobCOROUTINE$4, CoroutineImpl);
initMetadataForClass(NetworkJobManager, 'NetworkJobManager', NetworkJobManager, VOID, VOID, [2, 1]);
initMetadataForInterface(JsBearerTokenProvider, 'JsBearerTokenProvider');
//endregion
function buildCurlBreadcrumb($this, request) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder_init_$Create$();
  this_0.b8('curl -X ' + request.q4r_1.n41_1 + " '" + request.p4r_1.b46() + "'");
  var tmp = request.r4r_1.r2f();
  tmp.j3q(Client$Companion$buildCurlBreadcrumb$lambda(this_0));
  var body = request.s4r_1;
  if (body instanceof ByteArrayContent) {
    var tmp0_safe_receiver = body.r46();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this_0.b8(" -H 'Content-Type: " + tmp0_safe_receiver.toString() + "'");
    }
    var bodyText = decodeToString(body.t46());
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(bodyText) > 0) {
      this_0.b8(" -d '" + replace(bodyText, "'", "'\"'\"'") + "'");
    }
  }
  return this_0.toString();
}
function buildResponseBreadcrumb($this, response) {
  var status = response.c4u();
  var method = response.y4u().y4t().v4u().n41_1;
  var url = response.y4u().y4t().b4u();
  return '' + status.z43_1 + ' ' + status.a44_1 + ' | ' + method + ' ' + url.toString();
}
function setAppInfoHeaders($this, _this__u8e3s4, environmentProvider) {
  _this__u8e3s4.m51_1.p3q('X-OS-VERSION', environmentProvider.k37());
  _this__u8e3s4.m51_1.p3q('X-APP-BUILD-VERSION', environmentProvider.l37());
  _this__u8e3s4.m51_1.p3q('X-APP-MARKETING-VERSION', environmentProvider.m37());
  _this__u8e3s4.m51_1.p3q('X-APP-NAME', environmentProvider.n37());
  _this__u8e3s4.m51_1.p3q('X-PLATFORM', toNetworkString($this, environmentProvider.o37()));
}
function toNetworkString($this, _this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.l2_1) {
    case 0:
      tmp = 'ios';
      break;
    case 1:
      tmp = 'android';
      break;
    case 2:
      tmp = 'web';
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function ensureTrailingSlash($this, _this__u8e3s4) {
  return endsWith(_this__u8e3s4, '/') ? _this__u8e3s4 : _this__u8e3s4 + '/';
}
function httpClient$ref() {
  var l = function (p0) {
    return httpClient(p0);
  };
  l.callableName = 'httpClient';
  return l;
}
function Client$Companion$create$lambda$lambda($isDebug) {
  return function ($this$install) {
    json($this$install, jsonParser($isDebug));
    return Unit_instance;
  };
}
function Client$Companion$create$lambda$lambda_0($environmentProvider, $projectInfo) {
  return function ($this$install) {
    var appName = $environmentProvider.n37();
    var marketingVersion = $environmentProvider.m37();
    var platformName = toNetworkString(Companion_instance_2, $environmentProvider.o37());
    var osVersion = $environmentProvider.k37();
    var appBuildVersion = $environmentProvider.l37();
    var projectName = $projectInfo.a6k_1;
    var projectVersion = $projectInfo.b6k_1;
    $this$install.v5g_1 = appName + '/' + marketingVersion + ' (' + platformName + '/' + osVersion + '; build/' + appBuildVersion + '; ' + projectName + '/' + projectVersion + ')';
    return Unit_instance;
  };
}
function Client$Companion$create$lambda$lambda$lambda($this_defaultRequest, $environmentProvider) {
  return function ($this$headers) {
    Companion_getInstance_2().e6k($this$headers);
    setAppInfoHeaders(Companion_instance_2, $this_defaultRequest, $environmentProvider);
    return Unit_instance;
  };
}
function Client$Companion$create$lambda$lambda_1($networkDataProvider, $environmentProvider) {
  return function ($this$defaultRequest) {
    $this$defaultRequest.t51(ensureTrailingSlash(Companion_instance_2, $networkDataProvider.f6k()));
    headers($this$defaultRequest, Client$Companion$create$lambda$lambda$lambda($this$defaultRequest, $environmentProvider));
    return Unit_instance;
  };
}
function Client$Companion$create$lambda($isDebug, $environmentProvider, $projectInfo, $networkDataProvider) {
  return function ($this$httpClient) {
    var tmp = get_ContentNegotiation();
    $this$httpClient.w4s(tmp, Client$Companion$create$lambda$lambda($isDebug));
    var tmp_0 = get_UserAgent();
    $this$httpClient.w4s(tmp_0, Client$Companion$create$lambda$lambda_0($environmentProvider, $projectInfo));
    defaultRequest($this$httpClient, Client$Companion$create$lambda$lambda_1($networkDataProvider, $environmentProvider));
    return Unit_instance;
  };
}
function Client$Companion$create$slambda($networkDataProvider, resultContinuation) {
  this.o6k_1 = $networkDataProvider;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(Client$Companion$create$slambda).q5i = function ($this$intercept, request, $completion) {
  var tmp = this.r5i($this$intercept, request, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(Client$Companion$create$slambda).i9 = function (p1, p2, $completion) {
  var tmp = (!(p1 == null) ? isInterface(p1, Sender) : false) ? p1 : THROW_CCE();
  return this.q5i(tmp, p2 instanceof HttpRequestBuilder ? p2 : THROW_CCE(), $completion);
};
protoOf(Client$Companion$create$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.n8_1 = 1;
          suspendResult = setAuth(this.q6k_1, this.o6k_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.n8_1 = 2;
          suspendResult = this.p6k_1.i5f(this.q6k_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          return suspendResult;
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(Client$Companion$create$slambda).r5i = function ($this$intercept, request, completion) {
  var i = new Client$Companion$create$slambda(this.o6k_1, completion);
  i.p6k_1 = $this$intercept;
  i.q6k_1 = request;
  return i;
};
function Client$Companion$create$slambda_0($networkDataProvider, resultContinuation) {
  var i = new Client$Companion$create$slambda($networkDataProvider, resultContinuation);
  var l = function ($this$intercept, request, $completion) {
    return i.q5i($this$intercept, request, $completion);
  };
  l.$arity = 2;
  return l;
}
function Client$Companion$create$slambda_1($logger, resultContinuation) {
  this.z6k_1 = $logger;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(Client$Companion$create$slambda_1).q5i = function ($this$intercept, request, $completion) {
  var tmp = this.r5i($this$intercept, request, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(Client$Companion$create$slambda_1).i9 = function (p1, p2, $completion) {
  var tmp = (!(p1 == null) ? isInterface(p1, Sender) : false) ? p1 : THROW_CCE();
  return this.q5i(tmp, p2 instanceof HttpRequestBuilder ? p2 : THROW_CCE(), $completion);
};
protoOf(Client$Companion$create$slambda_1).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.z6k_1.i6e(Companion_instance_0.t6e(buildCurlBreadcrumb(Companion_instance_2, this.b6l_1), BreadcrumbCategory_CURL_getInstance()));
          this.n8_1 = 1;
          suspendResult = this.a6l_1.i5f(this.b6l_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var call = suspendResult;
          this.z6k_1.i6e(Companion_instance_0.t6e(buildResponseBreadcrumb(Companion_instance_2, call.p4q()), BreadcrumbCategory_RESPONSE_getInstance()));
          return call;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(Client$Companion$create$slambda_1).r5i = function ($this$intercept, request, completion) {
  var i = new Client$Companion$create$slambda_1(this.z6k_1, completion);
  i.a6l_1 = $this$intercept;
  i.b6l_1 = request;
  return i;
};
function Client$Companion$create$slambda_2($logger, resultContinuation) {
  var i = new Client$Companion$create$slambda_1($logger, resultContinuation);
  var l = function ($this$intercept, request, $completion) {
    return i.q5i($this$intercept, request, $completion);
  };
  l.$arity = 2;
  return l;
}
function Client$Companion$buildCurlBreadcrumb$lambda($$this$buildString) {
  return function (key, values) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = values.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      $$this$buildString.b8(" -H '" + key + ': ' + element + "'");
    }
    return Unit_instance;
  };
}
function Companion() {
  this.c6l_1 = 'NO_AUTH';
}
protoOf(Companion).d6l = function (loggingProvider, projectInfo, networkDataProvider, environmentProvider, httpClient) {
  var isDebug = loggingProvider.b6f();
  var logger = loggingProvider.r6e();
  var ktorClient = httpClient(Client$Companion$create$lambda(isDebug, environmentProvider, projectInfo, networkDataProvider));
  var tmp = plugin(ktorClient, Plugin_getInstance());
  tmp.u5g(Client$Companion$create$slambda_0(networkDataProvider, null));
  if (isDebug) {
    var tmp_0 = plugin(ktorClient, Plugin_getInstance());
    tmp_0.u5g(Client$Companion$create$slambda_2(logger, null));
  }
  return new Client(ktorClient);
};
protoOf(Companion).e6l = function (loggingProvider, projectInfo, networkDataProvider, environmentProvider, httpClient, $super) {
  var tmp;
  if (httpClient === VOID) {
    tmp = httpClient$ref();
  } else {
    tmp = httpClient;
  }
  httpClient = tmp;
  return $super === VOID ? this.d6l(loggingProvider, projectInfo, networkDataProvider, environmentProvider, httpClient) : $super.d6l.call(this, loggingProvider, projectInfo, networkDataProvider, environmentProvider, httpClient);
};
var Companion_instance_2;
function Companion_getInstance_1() {
  return Companion_instance_2;
}
function Client(httpClient) {
  this.f6l_1 = httpClient;
}
function get_sharedJson() {
  _init_properties_JsonParser_kt__kkrkav();
  return sharedJson;
}
var sharedJson;
function jsonParser(isDebug) {
  _init_properties_JsonParser_kt__kkrkav();
  var tmp = get_sharedJson();
  return Json(tmp, jsonParser$lambda(isDebug));
}
function sharedJson$lambda($this$Json) {
  _init_properties_JsonParser_kt__kkrkav();
  $this$Json.l60_1 = false;
  $this$Json.k60_1 = true;
  $this$Json.j60_1 = false;
  $this$Json.i60_1 = false;
  return Unit_instance;
}
function jsonParser$lambda($isDebug) {
  return function ($this$Json) {
    $this$Json.m60_1 = $isDebug;
    return Unit_instance;
  };
}
var properties_initialized_JsonParser_kt_vl8513;
function _init_properties_JsonParser_kt__kkrkav() {
  if (!properties_initialized_JsonParser_kt_vl8513) {
    properties_initialized_JsonParser_kt_vl8513 = true;
    sharedJson = Json(VOID, sharedJson$lambda);
  }
}
function orFalse(_this__u8e3s4) {
  return _this__u8e3s4 == null ? false : _this__u8e3s4;
}
function get_networkModule() {
  _init_properties_NetworkModule_kt__uh6uyg();
  return networkModule;
}
var networkModule;
function networkModule$lambda($this$module) {
  _init_properties_NetworkModule_kt__uh6uyg();
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2 = networkModule$lambda$lambda;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier = Companion_getInstance_0().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind = Kind_Factory_getInstance();
  var secondaryTypes = emptyList();
  var def = new BeanDefinition(scopeQualifier, getKClass(Client), null, tmp2, kind, secondaryTypes);
  var factory = new FactoryInstanceFactory(def);
  $this$module.p1c(factory);
  new KoinDefinition($this$module, factory);
  return Unit_instance;
}
function networkModule$lambda$lambda($this$factory, it) {
  _init_properties_NetworkModule_kt__uh6uyg();
  var tmp = Companion_instance_2;
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_0 = $this$factory.q1d(getKClass(ILoggingProvider), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_1 = $this$factory.q1d(getKClass(ProjectInfo), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_2 = $this$factory.q1d(getKClass(INetworkDataProvider), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$3 = $this$factory.q1d(getKClass(IEnvironmentProvider), null, null);
  return tmp.e6l(tmp_0, tmp_1, tmp_2, tmp$ret$3);
}
var properties_initialized_NetworkModule_kt_a8gwnq;
function _init_properties_NetworkModule_kt__uh6uyg() {
  if (!properties_initialized_NetworkModule_kt_a8gwnq) {
    properties_initialized_NetworkModule_kt_a8gwnq = true;
    networkModule = module_0(VOID, networkModule$lambda);
  }
}
function mapApiErrorResponse(response, $completion) {
  var tmp = new $mapApiErrorResponseCOROUTINE$0(response, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function $mapApiErrorResponseCOROUTINE$0(response, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.o6l_1 = response;
}
protoOf($mapApiErrorResponseCOROUTINE$0).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.o8_1 = 2;
          var tmp_0 = this;
          tmp_0.q6l_1 = Companion_instance;
          var tmp_1 = this;
          tmp_1.r6l_1 = this.o6l_1;
          this.s6l_1 = this.r6l_1;
          this.n8_1 = 1;
          var tmp_2 = this.s6l_1.y4u();
          var tmp_3 = getKClass(ErrorResponse);
          var tmp_4;
          try {
            tmp_4 = createKType(getKClass(ErrorResponse), arrayOf([]), false);
          } catch ($p) {
            var tmp_5;
            if ($p instanceof Error) {
              var _unused_var__etf5q3 = $p;
              tmp_5 = null;
            } else {
              throw $p;
            }
            tmp_4 = tmp_5;
          }

          suspendResult = tmp_2.a4u(new TypeInfo(tmp_3, tmp_4), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var tmp1 = suspendResult instanceof ErrorResponse ? suspendResult : THROW_CCE();
          var tmp_6 = this;
          this.q6l_1;
          tmp_6.p6l_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 3;
          this.n8_1 = 4;
          continue $sm;
        case 2:
          this.o8_1 = 3;
          var tmp_7 = this.q8_1;
          if (tmp_7 instanceof CancellationException) {
            var e = this.q8_1;
            var tmp_8 = this;
            throw e;
          } else {
            var tmp_9 = this.q8_1;
            if (tmp_9 instanceof Error) {
              var e_0 = this.q8_1;
              var tmp_10 = this;
              tmp_10.p6l_1 = _Result___init__impl__xyqfz8(createFailure(e_0));
              this.n8_1 = 4;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 3:
          throw this.q8_1;
        case 4:
          this.o8_1 = 3;
          var this_0 = this.p6l_1;
          var tmp_11;
          if (_Result___get_isFailure__impl__jpiriv(this_0)) {
            tmp_11 = null;
          } else {
            var tmp_12 = _Result___get_value__impl__bjfvqg(this_0);
            tmp_11 = (tmp_12 == null ? true : !(tmp_12 == null)) ? tmp_12 : THROW_CCE();
          }

          var errorResponse = tmp_11;
          var tmp1_elvis_lhs = errorResponse == null ? null : errorResponse.t6l_1;
          var errorMessage = tmp1_elvis_lhs == null ? 'Unknown error' : tmp1_elvis_lhs;
          var tmp2_subject = this.o6l_1.c4u().z43_1;
          return tmp2_subject === 400 ? new BadRequest(errorMessage) : tmp2_subject === 401 ? new Unauthorized(errorMessage) : tmp2_subject === 403 ? new Forbidden(errorMessage) : tmp2_subject === 404 ? new NotFound(errorMessage) : tmp2_subject === 409 ? new Conflict(errorMessage) : (500 <= tmp2_subject ? tmp2_subject <= 599 : false) ? Companion_instance_1.l2u("We're having trouble communicating with 7shifts right now. Please give it another shot!") : Companion_instance_1.l2u(errorMessage);
      }
    } catch ($p) {
      var e_1 = $p;
      if (this.o8_1 === 3) {
        throw e_1;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_1;
      }
    }
   while (true);
};
var ApiVersion_JUNE_2024_instance;
var ApiVersion_NOVEMBER_2025_instance;
var ApiVersion_FEBRUARY_2026_instance;
var ApiVersion_APRIL_2026_instance;
var ApiVersion_MAY_2026_instance;
var ApiVersion_JULY_2026_instance;
var ApiVersion_SEPTEMBER_2026_instance;
function Companion_0() {
  Companion_instance_3 = this;
  this.c6k_1 = 'x-api-version';
  this.d6k_1 = ApiVersion_JUNE_2024_getInstance();
}
protoOf(Companion_0).e6k = function (_this__u8e3s4) {
  appendIfNameAbsent(_this__u8e3s4, 'x-api-version', this.d6k_1.w6l_1);
};
protoOf(Companion_0).x6l = function (_this__u8e3s4, version) {
  _this__u8e3s4.p3q('x-api-version', version.w6l_1);
};
var Companion_instance_3;
function Companion_getInstance_2() {
  ApiVersion_initEntries();
  if (Companion_instance_3 == null)
    new Companion_0();
  return Companion_instance_3;
}
var ApiVersion_entriesInitialized;
function ApiVersion_initEntries() {
  if (ApiVersion_entriesInitialized)
    return Unit_instance;
  ApiVersion_entriesInitialized = true;
  ApiVersion_JUNE_2024_instance = new ApiVersion('JUNE_2024', 0, '2024-06-01');
  ApiVersion_NOVEMBER_2025_instance = new ApiVersion('NOVEMBER_2025', 1, '2025-11-01');
  ApiVersion_FEBRUARY_2026_instance = new ApiVersion('FEBRUARY_2026', 2, '2026-02-01');
  ApiVersion_APRIL_2026_instance = new ApiVersion('APRIL_2026', 3, '2026-04-01');
  ApiVersion_MAY_2026_instance = new ApiVersion('MAY_2026', 4, '2026-05-01');
  ApiVersion_JULY_2026_instance = new ApiVersion('JULY_2026', 5, '2026-07-01');
  ApiVersion_SEPTEMBER_2026_instance = new ApiVersion('SEPTEMBER_2026', 6, '2026-09-01');
  Companion_getInstance_2();
}
function ApiVersion(name, ordinal, versionName) {
  Enum.call(this, name, ordinal);
  this.w6l_1 = versionName;
}
function ApiVersion_JUNE_2024_getInstance() {
  ApiVersion_initEntries();
  return ApiVersion_JUNE_2024_instance;
}
function ApiVersion_FEBRUARY_2026_getInstance() {
  ApiVersion_initEntries();
  return ApiVersion_FEBRUARY_2026_instance;
}
function ApiVersion_APRIL_2026_getInstance() {
  ApiVersion_initEntries();
  return ApiVersion_APRIL_2026_instance;
}
function ApiVersion_MAY_2026_getInstance() {
  ApiVersion_initEntries();
  return ApiVersion_MAY_2026_instance;
}
function ApiVersion_JULY_2026_getInstance() {
  ApiVersion_initEntries();
  return ApiVersion_JULY_2026_instance;
}
function ProjectInfo(name, version) {
  this.a6k_1 = name;
  this.b6k_1 = version;
}
protoOf(ProjectInfo).toString = function () {
  return 'ProjectInfo(name=' + this.a6k_1 + ', version=' + this.b6k_1 + ')';
};
protoOf(ProjectInfo).hashCode = function () {
  var result = getStringHashCode(this.a6k_1);
  result = imul(result, 31) + getStringHashCode(this.b6k_1) | 0;
  return result;
};
protoOf(ProjectInfo).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ProjectInfo))
    return false;
  var tmp0_other_with_cast = other instanceof ProjectInfo ? other : THROW_CCE();
  if (!(this.a6k_1 === tmp0_other_with_cast.a6k_1))
    return false;
  if (!(this.b6k_1 === tmp0_other_with_cast.b6k_1))
    return false;
  return true;
};
function INetworkDataProvider() {
}
function $serializer() {
  $serializer_instance = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.infrastructure.network.responses.ApiPaginatedResponse.Meta', this, 1);
  tmp0_serialDesc.wy('cursor', false);
  this.z6l_1 = tmp0_serialDesc;
}
protoOf($serializer).a6m = function (encoder, value) {
  var tmp0_desc = this.z6l_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.bt(tmp0_desc, 0, $serializer_getInstance_0(), value.b6m_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer).yn = function (encoder, value) {
  return this.a6m(encoder, value instanceof Meta ? value : THROW_CCE());
};
protoOf($serializer).zn = function (decoder) {
  var tmp0_desc = this.z6l_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.kr(tmp0_desc);
  if (tmp5_input.as()) {
    tmp4_local0 = tmp5_input.wr(tmp0_desc, 0, $serializer_getInstance_0(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.wr(tmp0_desc, 0, $serializer_getInstance_0(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.lr(tmp0_desc);
  return Meta_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer).xn = function () {
  return this.z6l_1;
};
protoOf($serializer).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_0()];
};
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance == null)
    new $serializer();
  return $serializer_instance;
}
function Meta_init_$Init$(seen0, cursor, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance().z6l_1);
  }
  $this.b6m_1 = cursor;
  return $this;
}
function Meta_init_$Create$(seen0, cursor, serializationConstructorMarker) {
  return Meta_init_$Init$(seen0, cursor, serializationConstructorMarker, objectCreate(protoOf(Meta)));
}
function $serializer_0() {
  $serializer_instance_0 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.infrastructure.network.responses.ApiPaginatedResponse.Cursor', this, 4);
  tmp0_serialDesc.wy('current', false);
  tmp0_serialDesc.wy('prev', false);
  tmp0_serialDesc.wy('next', false);
  tmp0_serialDesc.wy('count', false);
  this.c6m_1 = tmp0_serialDesc;
}
protoOf($serializer_0).d6m = function (encoder, value) {
  var tmp0_desc = this.c6m_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.dt(tmp0_desc, 0, StringSerializer_getInstance(), value.e6m_1);
  tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.f6m_1);
  tmp1_output.dt(tmp0_desc, 2, StringSerializer_getInstance(), value.g6m_1);
  tmp1_output.us(tmp0_desc, 3, value.h6m_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_0).yn = function (encoder, value) {
  return this.d6m(encoder, value instanceof Cursor ? value : THROW_CCE());
};
protoOf($serializer_0).zn = function (decoder) {
  var tmp0_desc = this.c6m_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = 0;
  var tmp8_input = decoder.kr(tmp0_desc);
  if (tmp8_input.as()) {
    tmp4_local0 = tmp8_input.yr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp8_input.yr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp8_input.yr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp8_input.pr(tmp0_desc, 3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp8_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp8_input.yr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp8_input.yr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp8_input.yr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp8_input.pr(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp8_input.lr(tmp0_desc);
  return Cursor_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
};
protoOf($serializer_0).xn = function () {
  return this.c6m_1;
};
protoOf($serializer_0).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), IntSerializer_getInstance()];
};
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 == null)
    new $serializer_0();
  return $serializer_instance_0;
}
function Cursor_init_$Init$(seen0, current, prev, next, count, serializationConstructorMarker, $this) {
  if (!(15 === (15 & seen0))) {
    throwMissingFieldException(seen0, 15, $serializer_getInstance_0().c6m_1);
  }
  $this.e6m_1 = current;
  $this.f6m_1 = prev;
  $this.g6m_1 = next;
  $this.h6m_1 = count;
  return $this;
}
function Cursor_init_$Create$(seen0, current, prev, next, count, serializationConstructorMarker) {
  return Cursor_init_$Init$(seen0, current, prev, next, count, serializationConstructorMarker, objectCreate(protoOf(Cursor)));
}
function $serializer_init_$Init$(typeSerial0, $this) {
  $serializer_1.call($this);
  $this.j6m_1 = typeSerial0;
  return $this;
}
function $serializer_init_$Create$(typeSerial0) {
  return $serializer_init_$Init$(typeSerial0, objectCreate(protoOf($serializer_1)));
}
function Meta() {
}
protoOf(Meta).toString = function () {
  return 'Meta(cursor=' + this.b6m_1.toString() + ')';
};
protoOf(Meta).hashCode = function () {
  return this.b6m_1.hashCode();
};
protoOf(Meta).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Meta))
    return false;
  var tmp0_other_with_cast = other instanceof Meta ? other : THROW_CCE();
  if (!this.b6m_1.equals(tmp0_other_with_cast.b6m_1))
    return false;
  return true;
};
function Cursor() {
}
protoOf(Cursor).toString = function () {
  return 'Cursor(current=' + this.e6m_1 + ', prev=' + this.f6m_1 + ', next=' + this.g6m_1 + ', count=' + this.h6m_1 + ')';
};
protoOf(Cursor).hashCode = function () {
  var result = this.e6m_1 == null ? 0 : getStringHashCode(this.e6m_1);
  result = imul(result, 31) + (this.f6m_1 == null ? 0 : getStringHashCode(this.f6m_1)) | 0;
  result = imul(result, 31) + (this.g6m_1 == null ? 0 : getStringHashCode(this.g6m_1)) | 0;
  result = imul(result, 31) + this.h6m_1 | 0;
  return result;
};
protoOf(Cursor).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Cursor))
    return false;
  var tmp0_other_with_cast = other instanceof Cursor ? other : THROW_CCE();
  if (!(this.e6m_1 == tmp0_other_with_cast.e6m_1))
    return false;
  if (!(this.f6m_1 == tmp0_other_with_cast.f6m_1))
    return false;
  if (!(this.g6m_1 == tmp0_other_with_cast.g6m_1))
    return false;
  if (!(this.h6m_1 === tmp0_other_with_cast.h6m_1))
    return false;
  return true;
};
function Companion_1() {
  Companion_instance_4 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.infrastructure.network.responses.ApiPaginatedResponse', null, 2);
  tmp0_serialDesc.wy('data', false);
  tmp0_serialDesc.wy('meta', false);
  this.k6m_1 = tmp0_serialDesc;
}
protoOf(Companion_1).l6m = function (typeSerial0) {
  return $serializer_init_$Create$(typeSerial0);
};
protoOf(Companion_1).a10 = function (typeParamsSerializers) {
  return this.l6m(typeParamsSerializers[0]);
};
var Companion_instance_4;
function Companion_getInstance_3() {
  if (Companion_instance_4 == null)
    new Companion_1();
  return Companion_instance_4;
}
function $serializer_1() {
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.infrastructure.network.responses.ApiPaginatedResponse', this, 2);
  tmp0_serialDesc.wy('data', false);
  tmp0_serialDesc.wy('meta', false);
  this.i6m_1 = tmp0_serialDesc;
}
protoOf($serializer_1).m6m = function (encoder, value) {
  var tmp0_desc = this.i6m_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.bt(tmp0_desc, 0, new ArrayListSerializer(this.j6m_1), value.n6m_1);
  tmp1_output.bt(tmp0_desc, 1, $serializer_getInstance(), value.o6m_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_1).yn = function (encoder, value) {
  return this.m6m(encoder, value instanceof ApiPaginatedResponse ? value : THROW_CCE());
};
protoOf($serializer_1).zn = function (decoder) {
  var tmp0_desc = this.i6m_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.kr(tmp0_desc);
  if (tmp6_input.as()) {
    tmp4_local0 = tmp6_input.wr(tmp0_desc, 0, new ArrayListSerializer(this.j6m_1), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.wr(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.wr(tmp0_desc, 0, new ArrayListSerializer(this.j6m_1), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.wr(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.lr(tmp0_desc);
  return ApiPaginatedResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_1).xn = function () {
  return this.i6m_1;
};
protoOf($serializer_1).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [new ArrayListSerializer(this.j6m_1), $serializer_getInstance()];
};
protoOf($serializer_1).qz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [this.j6m_1];
};
function ApiPaginatedResponse_init_$Init$(seen0, data, meta, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, Companion_getInstance_3().k6m_1);
  }
  $this.n6m_1 = data;
  $this.o6m_1 = meta;
  return $this;
}
function ApiPaginatedResponse_init_$Create$(seen0, data, meta, serializationConstructorMarker) {
  return ApiPaginatedResponse_init_$Init$(seen0, data, meta, serializationConstructorMarker, objectCreate(protoOf(ApiPaginatedResponse)));
}
function ApiPaginatedResponse(data, meta) {
  Companion_getInstance_3();
  this.n6m_1 = data;
  this.o6m_1 = meta;
}
protoOf(ApiPaginatedResponse).toString = function () {
  return 'ApiPaginatedResponse(data=' + toString(this.n6m_1) + ', meta=' + this.o6m_1.toString() + ')';
};
protoOf(ApiPaginatedResponse).hashCode = function () {
  var result = hashCode(this.n6m_1);
  result = imul(result, 31) + this.o6m_1.hashCode() | 0;
  return result;
};
protoOf(ApiPaginatedResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiPaginatedResponse))
    return false;
  var tmp0_other_with_cast = other instanceof ApiPaginatedResponse ? other : THROW_CCE();
  if (!equals(this.n6m_1, tmp0_other_with_cast.n6m_1))
    return false;
  if (!this.o6m_1.equals(tmp0_other_with_cast.o6m_1))
    return false;
  return true;
};
function Companion_2() {
}
var Companion_instance_5;
function Companion_getInstance_4() {
  return Companion_instance_5;
}
function $serializer_2() {
  $serializer_instance_1 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.infrastructure.network.responses.ErrorResponse', this, 1);
  tmp0_serialDesc.wy('detail', false);
  this.p6m_1 = tmp0_serialDesc;
}
protoOf($serializer_2).q6m = function (encoder, value) {
  var tmp0_desc = this.p6m_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.dt(tmp0_desc, 0, StringSerializer_getInstance(), value.t6l_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_2).yn = function (encoder, value) {
  return this.q6m(encoder, value instanceof ErrorResponse ? value : THROW_CCE());
};
protoOf($serializer_2).zn = function (decoder) {
  var tmp0_desc = this.p6m_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.kr(tmp0_desc);
  if (tmp5_input.as()) {
    tmp4_local0 = tmp5_input.yr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.yr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.lr(tmp0_desc);
  return ErrorResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_2).xn = function () {
  return this.p6m_1;
};
protoOf($serializer_2).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(StringSerializer_getInstance())];
};
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 == null)
    new $serializer_2();
  return $serializer_instance_1;
}
function ErrorResponse_init_$Init$(seen0, detail, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_1().p6m_1);
  }
  $this.t6l_1 = detail;
  return $this;
}
function ErrorResponse_init_$Create$(seen0, detail, serializationConstructorMarker) {
  return ErrorResponse_init_$Init$(seen0, detail, serializationConstructorMarker, objectCreate(protoOf(ErrorResponse)));
}
function ErrorResponse(detail) {
  this.t6l_1 = detail;
}
protoOf(ErrorResponse).toString = function () {
  return 'ErrorResponse(detail=' + this.t6l_1 + ')';
};
protoOf(ErrorResponse).hashCode = function () {
  return this.t6l_1 == null ? 0 : getStringHashCode(this.t6l_1);
};
protoOf(ErrorResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ErrorResponse))
    return false;
  var tmp0_other_with_cast = other instanceof ErrorResponse ? other : THROW_CCE();
  if (!(this.t6l_1 == tmp0_other_with_cast.t6l_1))
    return false;
  return true;
};
function nullIfZero(_this__u8e3s4) {
  return _this__u8e3s4 === 0 ? null : _this__u8e3s4;
}
function nullIfZero_0(_this__u8e3s4) {
  return equals(_this__u8e3s4, new Long(0, 0)) ? null : _this__u8e3s4;
}
function getRaw(_this__u8e3s4, path, $completion) {
  var tmp = new $getRawCOROUTINE$1(_this__u8e3s4, path, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
}
function buildV2Path(_this__u8e3s4, path) {
  return 'v2/' + path;
}
function $getRawCOROUTINE$1(_this__u8e3s4, path, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.z6m_1 = _this__u8e3s4;
  this.a6n_1 = path;
}
protoOf($getRawCOROUTINE$1).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          this.o8_1 = 3;
          var tmp_0 = this;
          tmp_0.c6n_1 = Companion_instance;
          var tmp_1 = this;
          tmp_1.d6n_1 = this.z6m_1.f6l_1;
          var tmp_2 = this;
          tmp_2.e6n_1 = this.a6n_1;
          this.f6n_1 = this.d6n_1;
          this.g6n_1 = this.e6n_1;
          var tmp_3 = this;
          tmp_3.h6n_1 = this.f6n_1;
          this.i6n_1 = this.h6n_1;
          var tmp_4 = this;
          tmp_4.j6n_1 = this.i6n_1;
          var tmp_5 = this;
          var this_0 = new HttpRequestBuilder();
          url(this_0, this.g6n_1);
          tmp_5.k6n_1 = this_0;
          this.l6n_1 = this.j6n_1;
          this.m6n_1 = this.k6n_1;
          this.m6n_1.q4r_1 = Companion_getInstance().f41_1;
          var tmp_6 = this;
          tmp_6.n6n_1 = this.l6n_1;
          var tmp_7 = this;
          tmp_7.o6n_1 = this.m6n_1;
          this.p6n_1 = this.n6n_1;
          this.q6n_1 = this.o6n_1;
          this.n8_1 = 1;
          suspendResult = (new HttpStatement(this.q6n_1, this.p6n_1)).e5t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.r6n_1 = suspendResult;
          this.n8_1 = 2;
          suspendResult = bodyAsText(this.r6n_1, VOID, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          var tmp1 = suspendResult;
          var tmp_8 = this;
          this.c6n_1;
          tmp_8.b6n_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 4;
          this.n8_1 = 5;
          continue $sm;
        case 3:
          this.o8_1 = 4;
          var tmp_9 = this.q8_1;
          if (tmp_9 instanceof CancellationException) {
            var e = this.q8_1;
            var tmp_10 = this;
            throw e;
          } else {
            var tmp_11 = this.q8_1;
            if (tmp_11 instanceof Error) {
              var e_0 = this.q8_1;
              var tmp_12 = this;
              tmp_12.b6n_1 = _Result___init__impl__xyqfz8(createFailure(e_0));
              this.n8_1 = 5;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 4:
          throw this.q8_1;
        case 5:
          this.o8_1 = 4;
          var this_1 = this.b6n_1;
          var exception = Result__exceptionOrNull_impl_p6xea9(this_1);
          var tmp_13;
          if (exception == null) {
            var tmp_14 = _Result___get_value__impl__bjfvqg(this_1);
            var value = (tmp_14 == null ? true : !(tmp_14 == null)) ? tmp_14 : THROW_CCE();
            tmp_13 = new Result(_Result___init__impl__xyqfz8(value));
          } else {
            var exception_0 = Companion_instance_1.b2u(exception);
            tmp_13 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_0)));
          }

          return tmp_13;
      }
    } catch ($p) {
      var e_1 = $p;
      if (this.o8_1 === 4) {
        throw e_1;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_1;
      }
    }
   while (true);
};
function NetworkJobManager$registerJob$slambda$slambda($job, resultContinuation) {
  this.a6o_1 = $job;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(NetworkJobManager$registerJob$slambda$slambda).c6o = function ($this$async, $completion) {
  var tmp = this.s3m($this$async, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(NetworkJobManager$registerJob$slambda$slambda).h9 = function (p1, $completion) {
  return this.c6o((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(NetworkJobManager$registerJob$slambda$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.a6o_1(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return suspendResult;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(NetworkJobManager$registerJob$slambda$slambda).s3m = function ($this$async, completion) {
  var i = new NetworkJobManager$registerJob$slambda$slambda(this.a6o_1, completion);
  i.b6o_1 = $this$async;
  return i;
};
function NetworkJobManager$registerJob$slambda$slambda_0($job, resultContinuation) {
  var i = new NetworkJobManager$registerJob$slambda$slambda($job, resultContinuation);
  var l = function ($this$async, $completion) {
    return i.c6o($this$async, $completion);
  };
  l.$arity = 1;
  return l;
}
function registerJob($this, key, job, $completion) {
  var tmp = new $registerJobCOROUTINE$3($this, key, job, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function unregisterJob($this, key, $completion) {
  var tmp = new $unregisterJobCOROUTINE$4($this, key, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function NetworkJobManager$registerJob$slambda(this$0, $key, $job, resultContinuation) {
  this.m6p_1 = this$0;
  this.n6p_1 = $key;
  this.o6p_1 = $job;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(NetworkJobManager$registerJob$slambda).t6p = function ($this$coroutineScope, $completion) {
  var tmp = this.s3m($this$coroutineScope, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(NetworkJobManager$registerJob$slambda).h9 = function (p1, $completion) {
  return this.t6p((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(NetworkJobManager$registerJob$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          var tmp_0 = this;
          tmp_0.q6p_1 = this.m6p_1.v6p_1;
          this.r6p_1 = this.q6p_1;
          var tmp_1 = this;
          tmp_1.s6p_1 = null;
          this.n8_1 = 1;
          suspendResult = this.r6p_1.y27(this.s6p_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var tmp$ret$0 = Unit_instance;
          l$ret$1: do {
            var tmp_2;
            try {
              var tmp0 = this.m6p_1.u6p_1;
              var key = this.n6p_1;
              var value = tmp0.a2(key);
              var tmp_3;
              if (value == null) {
                var answer = async(this.p6p_1, VOID, VOID, NetworkJobManager$registerJob$slambda$slambda_0(this.o6p_1, null));
                tmp0.h2(key, answer);
                tmp_3 = answer;
              } else {
                tmp_3 = value;
              }
              tmp$ret$0 = tmp_3;
              break l$ret$1;
            } catch ($p) {
              var tmp_4;
              var t = $p;
              this.r6p_1.k27(this.s6p_1);
              throw t;
            }
          }
           while (false);
          var tmp_5 = tmp$ret$0;
          this.r6p_1.k27(this.s6p_1);
          return tmp_5;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(NetworkJobManager$registerJob$slambda).s3m = function ($this$coroutineScope, completion) {
  var i = new NetworkJobManager$registerJob$slambda(this.m6p_1, this.n6p_1, this.o6p_1, completion);
  i.p6p_1 = $this$coroutineScope;
  return i;
};
function NetworkJobManager$registerJob$slambda_0(this$0, $key, $job, resultContinuation) {
  var i = new NetworkJobManager$registerJob$slambda(this$0, $key, $job, resultContinuation);
  var l = function ($this$coroutineScope, $completion) {
    return i.t6p($this$coroutineScope, $completion);
  };
  l.$arity = 1;
  return l;
}
function $executeCOROUTINE$2(_this__u8e3s4, key, job, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.e6q_1 = _this__u8e3s4;
  this.f6q_1 = key;
  this.g6q_1 = job;
}
protoOf($executeCOROUTINE$2).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          this.n8_1 = 1;
          suspendResult = registerJob(this.e6q_1, this.f6q_1, this.g6q_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.h6q_1 = suspendResult;
          this.n8_1 = 2;
          suspendResult = this.h6q_1.e1h(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.i6q_1 = suspendResult;
          this.j6q_1 = this.i6q_1;
          var tmp_0 = this;
          tmp_0.k6q_1 = this.j6q_1.ul_1;
          this.l6q_1 = this.k6q_1;
          this.n8_1 = 3;
          suspendResult = unregisterJob(this.e6q_1, this.f6q_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 3:
          return this.j6q_1;
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $registerJobCOROUTINE$3(_this__u8e3s4, key, job, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.l6o_1 = _this__u8e3s4;
  this.m6o_1 = key;
  this.n6o_1 = job;
}
protoOf($registerJobCOROUTINE$3).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 5;
          var tmp_0 = this;
          tmp_0.o6o_1 = this.l6o_1.v6p_1;
          this.p6o_1 = this.o6o_1;
          var tmp_1 = this;
          tmp_1.q6o_1 = null;
          this.n8_1 = 1;
          suspendResult = this.p6o_1.y27(this.q6o_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var tmp$ret$0 = Unit_instance;
          l$ret$1: do {
            var tmp_2;
            try {
              var tmp0_safe_receiver = this.l6o_1.u6p_1.a2(this.m6o_1);
              tmp$ret$0 = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e1f()) === true;
              break l$ret$1;
            } catch ($p) {
              var tmp_3;
              var t = $p;
              this.p6o_1.k27(this.q6o_1);
              throw t;
            }
          }
           while (false);
          var tmp_4 = tmp$ret$0;
          this.p6o_1.k27(this.q6o_1);
          if (tmp_4) {
            this.n8_1 = 2;
            suspendResult = unregisterJob(this.l6o_1, this.m6o_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.n8_1 = 3;
            continue $sm;
          }

        case 2:
          this.n8_1 = 3;
          continue $sm;
        case 3:
          this.n8_1 = 4;
          suspendResult = coroutineScope(NetworkJobManager$registerJob$slambda_0(this.l6o_1, this.m6o_1, this.n6o_1, null), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 4:
          return suspendResult;
        case 5:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 5) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $unregisterJobCOROUTINE$4(_this__u8e3s4, key, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.z6o_1 = _this__u8e3s4;
  this.a6p_1 = key;
}
protoOf($unregisterJobCOROUTINE$4).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          var tmp_0 = this;
          tmp_0.b6p_1 = this.z6o_1.v6p_1;
          this.c6p_1 = this.b6p_1;
          var tmp_1 = this;
          tmp_1.d6p_1 = null;
          this.n8_1 = 1;
          suspendResult = this.c6p_1.y27(this.d6p_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          l$ret$1: do {
            var tmp_2;
            try {
              this.z6o_1.u6p_1.i2(this.a6p_1);
              break l$ret$1;
            } catch ($p) {
              var tmp_3;
              var t = $p;
              this.c6p_1.k27(this.d6p_1);
              throw t;
            }
          }
           while (false);
          this.c6p_1.k27(this.d6p_1);
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function NetworkJobManager() {
  var tmp = this;
  // Inline function 'kotlin.collections.mutableMapOf' call
  tmp.u6p_1 = LinkedHashMap_init_$Create$();
  this.v6p_1 = Mutex();
}
protoOf(NetworkJobManager).m6q = function (key, job, $completion) {
  var tmp = new $executeCOROUTINE$2(this, key, job, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(NetworkJobManager).n6q = function (key, job, $completion, $super) {
  key = key === VOID ? Unit_instance : key;
  return $super === VOID ? this.m6q(key, job, $completion) : $super.m6q.call(this, key, job, $completion);
};
function httpClient(config) {
  var tmp = Js_instance;
  return HttpClient(tmp, httpClient$lambda(config));
}
function setAuth(request, networkDataProvider, $completion) {
  if (request.r4r_1.o3q('NO_AUTH')) {
    request.r4r_1.u3q('NO_AUTH');
  } else {
    if (isInterface(networkDataProvider, JsBearerTokenProvider)) {
      var token = networkDataProvider.o6q();
      // Inline function 'kotlin.text.isNullOrEmpty' call
      if (!(token == null || charSequenceLength(token) === 0)) {
        bearerAuth(request, token);
      }
    }
  }
  return Unit_instance;
}
function httpClient$lambda($config) {
  return function ($this$HttpClient) {
    $config($this$HttpClient);
    return Unit_instance;
  };
}
function JsBearerTokenProvider() {
}
//region block: post-declaration
protoOf($serializer).qz = typeParametersSerializers;
protoOf($serializer_0).qz = typeParametersSerializers;
protoOf($serializer_2).qz = typeParametersSerializers;
//endregion
//region block: init
Companion_instance_2 = new Companion();
Companion_instance_5 = new Companion_2();
//endregion
//region block: exports
export {
  get_networkModule as get_networkModulele1z108kpokz,
  ProjectInfo as ProjectInfo1qp9h4onrx4i2,
  INetworkDataProvider as INetworkDataProvider2v0ql8qlip169,
  JsBearerTokenProvider as JsBearerTokenProvider2wbeaqbjwnd48,
  ApiPaginatedResponse as ApiPaginatedResponse21k9qwv83e5dh,
  NetworkJobManager as NetworkJobManager330ytw7ckzld9,
  buildV2Path as buildV2Path1ie1ylvss3rsk,
  nullIfZero as nullIfZero2w6gbitjuuknl,
  nullIfZero_0 as nullIfZeroqaja8qzkwg8f,
  Client as Clientssjxb7gh2u6y,
  httpClient as httpClient2muhbitsbcjn6,
  orFalse as orFalse20exmi7skltjp,
  get_sharedJson as get_sharedJson2ja82jrdlkmvt,
  ApiVersion_APRIL_2026_getInstance as ApiVersion_APRIL_2026_getInstance1y3s521mv7m63,
  ApiVersion_FEBRUARY_2026_getInstance as ApiVersion_FEBRUARY_2026_getInstancexhgc3m6uvy4r,
  ApiVersion_JULY_2026_getInstance as ApiVersion_JULY_2026_getInstance26s1g5r9ct27x,
  ApiVersion_MAY_2026_getInstance as ApiVersion_MAY_2026_getInstance1jn2lakqb99ub,
  mapApiErrorResponse as mapApiErrorResponse18m737xo6p7hy,
  getRaw as getRaw1iqjzl4utwpzp,
  Companion_getInstance_2 as Companion_getInstance35hsivaslc5e3,
  Companion_instance_2 as Companion_instance2qqqduu61k50l,
};
//endregion

